define(function (require) {

    var agentLEManager = require('web-agent-utils/agentLEManager');
    var BaseApiService = require('web-agent-utils/BaseApiService');

    var applicationType = "AgentOutcomes";

    var visitManagerResources = agentLEManager.getLEUrlResolverApiResourcesService("Smt");
    var agentSDEResource;

    if (visitManagerResources && visitManagerResources[applicationType] && visitManagerResources[applicationType].url) {
        var fullResourceUrl = agentLEManager.getLEUrlResolverGetUrl(visitManagerResources[applicationType].url);
        var resourceDomainUrl = agentLEManager.getLEUrlResolverGetUrlParts(fullResourceUrl).origin;
        agentSDEResource = BaseApiService.createInstance({domainUrl: resourceDomainUrl, postmessagePath: "/postmessage", serviceName: applicationType});
    }

    return {
        pushSDE: function (request, visitorId, sid) {
            var reqObj = {
                method: 'PUT',
                callingFunction: applicationType,
                query: {
                    sid: sid
                },
                data: request.data,
                success: request.success,
                error: request.error,
                context: request.context
            };
            reqObj.url = fullResourceUrl.replace("{visitorId}", visitorId + "");
            reqObj = agentSDEResource.createBasicRequest(reqObj);
            agentSDEResource.sendRequest(reqObj);
        }
    };

});
